import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Navigation.
 *
 * This used to hide a real difference: mounted inside the Angular host the URL
 * belonged to Angular's Router, so navigating meant handing the target to the
 * host and waiting for it to push the path back down. Standalone it belonged
 * to react-router. `useHostNavigate` was the seam between the two.
 *
 * There is no host any more, so this is react-router's `useNavigate` narrowed
 * to the one shape every caller uses. The name is a leftover — forty files
 * import it, and renaming them belongs in its own change rather than in the
 * one that removed the host.
 */
export type HostNavigate = (url: string, options?: { replace?: boolean }) => void;

export function useHostNavigate(): HostNavigate {
  const navigate = useNavigate();
  return useCallback(
    // One-argument calls stay one-argument, as callers and their tests expect.
    (url: string, options?: { replace?: boolean }) =>
      options ? navigate(url, options) : navigate(url),
    [navigate],
  );
}
